import { Node, Edge, useStore } from '@xyflow/react';
import { useMemo } from 'react';
import { sameGraphSelection } from '../../Services/GraphRenderState';

export default function useFlowGraphState<TNode extends Node, TEdge extends Edge>() {
	const nodes = useStore((store) => store.nodes as TNode[], sameGraphSelection);
	const edges = useStore((store) => store.edges as TEdge[]);
	const selectedNode = useMemo(() => nodes.find((node) => node.selected), [nodes]);
	const selectedEdge = useMemo(() => edges.find((edge) => edge.selected), [edges]);
	return useMemo(() => ({ selectedNode, nodes, selectedEdge, edges }), [selectedNode, nodes, selectedEdge, edges]);
}
